import { render, staticRenderFns } from "./OverallChapterHealth.vue?vue&type=template&id=7fae930e&scoped=true&"
import script from "./OverallChapterHealth.vue?vue&type=script&lang=js&"
export * from "./OverallChapterHealth.vue?vue&type=script&lang=js&"
import style0 from "./OverallChapterHealth.vue?vue&type=style&index=0&id=7fae930e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae930e",
  null
  
)

export default component.exports